import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import useFromValidator from "../../../common/formValidator";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";

const schema = {
  taxPercentage: {
    presence: { allowEmpty: false, message: " is required" },
    type: "number",
    numericality: {
      greaterThanOrEqualTo: 0,
    },
  },
  taxTypeIndex: {
    presence: { allowEmpty: false, message: " is required" },
  },
  taxProfileName: {
    presence: { allowEmpty: false, message: " is required" },
    type: "string",
  },
};

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(0),
    color: theme.palette.text.default,
  },
  formControl: {
    // margin: theme.spacing(1),
    // minWidth: 120,
  },
  textField: {
    // marginTop: theme.spacing(2),
  },
  signInButton: {
    margin: theme.spacing(2, 0),
  },
  progressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  progressBar: {
    margin: theme.spacing(2),
    position: "absolute",
    top: "40%",
    zIndex: "9999",
  },
}));

const TaxProfile = ({
  deleteErrorMessage,
  errorMessage,
  onEdit,
  taxTypes,
  data,
  onSave,
  handleClose,
  showDialog,
  editMode = false,
}) => {
  const classes = useStyles();
  const [formState, hasError, handleChange, updateData] =
    useFromValidator(schema);
  const [popupLoading, setPopupLoading] = useState(false);

  //Called if the Farm Property is Set for Editing
  const resetBeforeEdit = () => {
    if (editMode) {
      console.log("data", data);
    }
    if (showDialog) {
      setPopupLoading(false);
      updateData(data, editMode);
    }
  };
  useEffect(resetBeforeEdit, [showDialog]);

  const onSubmit = () => {
    setPopupLoading(true);
    const tempData = {
      ...formState.values,
      taxTypeId: taxTypes[formState.values.taxTypeIndex].id,
      taxType: taxTypes[formState.values.taxTypeIndex].taxType,
    };
    var errorElement = document.getElementById("error");
    if (errorElement) {
      errorElement.scrollIntoView();
    }
    if (editMode) {
      onEdit(tempData, setPopupLoading);
      console.log("tempdata", tempData);
    } else onSave(tempData, setPopupLoading);
  };

  return (
    <Dialog
      disableBackdropClick
      open={showDialog}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog- title">
        {editMode ? "Update" : "New"} Tax Profile Detail
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={handleClose}
        >
        <CloseIcon />
      </IconButton>
      </DialogTitle>
      <DialogContent>
        {popupLoading ? (
          <div>
            <div className={classes.progressContainer}>
              <CircularProgress className={classes.progressBar} />
            </div>
            <br />
            <br />
            <TextField
              disabled
              className={classes.textField}
              error={hasError("taxProfileName")}
              fullWidth
              helperText={
                hasError("taxProfileName")
                  ? formState.errors.taxPercentage[0]
                  : null
              }
              label="Tax Profile Name"
              name="taxProfileName"
              onChange={handleChange}
              type="text"
              value={formState.values.taxProfileName || ""}
              variant="outlined"
              style={{ backgroundColor: "#ffffff" }}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="type-select-outlined-label">Tax Type</InputLabel>
              <Select
                disabled
                id="taxType"
                value={
                  formState.values.taxTypeIndex !== undefined
                    ? formState.values.taxTypeIndex
                    : ""
                }
                onChange={handleChange}
                name="taxTypeIndex"
              >
                {taxTypes !== undefined && taxTypes !== null
                  ? taxTypes.map((tax, index) => (
                      <MenuItem key={tax.id} value={index}>
                        {tax.taxType}
                      </MenuItem>
                    ))
                  : ""}
              </Select>
            </FormControl>
            <TextField
              disabled
              className={classes.textField}
              error={hasError("taxPercentage")}
              fullWidth
              helperText={
                hasError("taxPercentage")
                  ? formState.errors.taxPercentage[0]
                  : null
              }
              label="Tax Percentage"
              name="taxPercentage"
              onChange={handleChange}
              type="number"
              value={formState.values.taxPercentage || ""}
              variant="outlined"
              style={{ backgroundColor: "#ffffff" }}
            />
            <DialogActions>
              <Button
                className={classes.signInButton}
                color="primary"
                disabled
                size="large"
                type="submit"
                variant="contained"
                onClick={onSubmit}
              >
                Save
              </Button>
            </DialogActions>
          </div>
        ) : (
          <div>
            <div id="error">
              {errorMessage ? (
                <Chip
                  onDelete={deleteErrorMessage}
                  color="primary"
                  label={errorMessage}
                />
              ) : (
                ""
              )}
            </div>
            <br />
            <div className="grid-container">
            <TextField
              className={classes.textField}
              error={hasError("taxProfileName")}
              fullWidth
              helperText={
                hasError("taxProfileName")
                  ? formState.errors.taxProfileName[0]
                  : null
              }
              label="Tax Profile Name"
              name="taxProfileName"
              onChange={handleChange}
              type="text"
              value={formState.values.taxProfileName || ""}
              variant="outlined"
              style={{ backgroundColor: "#ffffff" }}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="type-select-outlined-label">Tax Type</InputLabel>
              <Select
                label='Tax Type'
                labelId="type-select-outlined-label"
                id="taxType"
                value={
                  formState.values.taxTypeIndex !== undefined
                    ? formState.values.taxTypeIndex
                    : ""
                }
                onChange={handleChange}
                name="taxTypeIndex"
              >
                {taxTypes !== undefined && taxTypes !== null
                  ? taxTypes.map((tax, index) => (
                      <MenuItem key={tax.id} value={index}>
                        {tax.taxType}
                      </MenuItem>
                    ))
                  : ""}
              </Select>
            </FormControl>

            <TextField
              className={classes.textField}
              error={hasError("taxPercentage")}
              fullWidth
              helperText={
                hasError("taxPercentage")
                  ? formState.errors.taxPercentage[0]
                  : null
              }
              label="Tax Percentage"
              name="taxPercentage"
              onChange={handleChange}
              type="number"
              value={formState.values.taxPercentage || ""}
              variant="outlined"
              style={{ backgroundColor: "#ffffff" }}
            />
            </div>

           
          </div>
        )}
      </DialogContent>
       <DialogActions>
              <Button
                className={classes.signInButton}
                color="primary"
                size="large"
                type="submit"
                variant="contained"
                disabled={!formState.isValid}
                onClick={onSubmit}
              >
                Save
              </Button>
            </DialogActions>
    </Dialog>
  );
};

export default TaxProfile;
